import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchTodos from "../redux/todos/thunk/fetchTodos";
import Todo from "./Todo";

export default function TodoList({ status }) {
  const todos = useSelector((state) => state.todos);
  const filters = useSelector((state) => state.filters);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchTodos);
  }, [dispatch]);

  const filterByStatus = (todo) => {
    const { status } = filters;
    switch (status) {
      case "Complete":
        return todo.completed;

      case "Incomplete":
        return !todo.completed;

      default:
        return true;
    }
  };

  const filterByColors = (todo) => {
    const { colors } = filters;
    if (colors.length > 0) {
      return colors.includes(todo?.color);
    }
    return true;
  };

  return (
    <div className="mt-2 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
      {todos
        .filter((todo) => {
          if (status) {
            return true;
          }
          return filterByColors(todo);
        })
        .filter((todo) => {
          if (status) {
            return true;
          }
          return filterByColors(todo);
        })
        .filter((todo) => {
          if (status) {
            return todo.completed;
          } else {
            return !todo.completed;
          }
        })
        .map((todo) => (
          <Todo todo={todo} status={status} key={todo.id} />
        ))}
    </div>
  );
}
